/**
 * The input box narrows while the assistant works and grows back to the full column width once
 * the answer stands — a quiet cue that the turn is with the assistant. Width, not opacity: the
 * field stays usable (a follow-up can be typed, the stop button stays where it is).
 *
 * Max-width is animated (a transition on `max-width`, not on `width`) so the box keeps its
 * block layout; `mx-auto` centres it while narrow. `motion-reduce` turns the glide into a cut.
 */
export const COMPOSER_WIDTH_PENDING = 'max-w-[640px]';
export const COMPOSER_WIDTH_IDLE = 'max-w-full';

export function composerWidthClass(pending: boolean): string {
    return [
        // one transition list: the box also fades its border colour (formerly `transition-colors`),
        // and two `transition-*` utilities would overwrite each other.
        'mx-auto w-full transition-[max-width,border-color,background-color] duration-500 ease-out motion-reduce:transition-none',
        pending ? COMPOSER_WIDTH_PENDING : COMPOSER_WIDTH_IDLE,
    ].join(' ');
}
